import { render, staticRenderFns } from "./ImageMessage.vue?vue&type=template&id=ad857a26&"
import script from "./ImageMessage.vue?vue&type=script&lang=js&"
export * from "./ImageMessage.vue?vue&type=script&lang=js&"
import style0 from "./ImageMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports